export default __webpack_public_path__ + "static/media/timer.355a0332.svg";